import {
  SandpackProvider,
  type SandpackProviderProps,
} from "@codesandbox/sandpack-react";

const MySandpackProvider: React.FC<SandpackProviderProps> = ({ ...props }) => {
  return <SandpackProvider {...props} />;
};

export default MySandpackProvider;
